import { Component, OnInit } from '@angular/core';
import { ApiService } from '../shared/services/api.service';

@Component({
    selector: 'splash',
    templateUrl: './splash.component.html',
    styleUrls: ['./splash.component.scss']
})

export class SplashComponent implements OnInit {

  constructor(
    private DataService: ApiService

    ) {
  }

  dataLoaded: boolean;

  ngOnInit() {
  	this.DataService.getData().then(res => this.dataLoaded = true);
  }

}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/splash/splash.component.ts